/**
 * Accessibility Enhancements
 * WCAG 2.1 Level AA Compliance
 */

document.addEventListener('DOMContentLoaded', function() {
  // 1. Keyboard Navigation for Dropdowns
  initializeDropdownKeyboardNav();
  
  // 2. Focus Management
  initializeFocusManagement();
  
  // 3. Live Region Announcements
  initializeLiveRegions();
  
  // 4. Modal Accessibility
  initializeModals();
  
  // 5. Skip Link Functionality
  initializeSkipLink();
});

/**
 * Initialize keyboard navigation for dropdowns
 */
function initializeDropdownKeyboardNav() {
  const dropdownButtons = document.querySelectorAll('[aria-haspopup="true"]');
  
  dropdownButtons.forEach(button => {
    button.addEventListener('keydown', function(e) {
      const isOpen = this.getAttribute('aria-expanded') === 'true';
      
      if (e.key === 'ArrowDown' && !isOpen) {
        e.preventDefault();
        this.click();
        const menu = document.getElementById(this.getAttribute('aria-controls'));
        if (menu) {
          const firstItem = menu.querySelector('a, button');
          if (firstItem) firstItem.focus();
        }
      }
      
      if (e.key === 'Escape' && isOpen) {
        e.preventDefault();
        this.click();
        this.focus();
      }
    });
  });
}

/**
 * Initialize focus management
 */
function initializeFocusManagement() {
  // Ensure main content can receive focus
  const main = document.querySelector('main');
  if (main && !main.hasAttribute('tabindex')) {
    main.setAttribute('tabindex', '-1');
  }
  
  // Add focus visible class for keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Tab') {
      document.body.classList.add('keyboard-nav');
    }
  });
  
  document.addEventListener('mousedown', function() {
    document.body.classList.remove('keyboard-nav');
  });
}

/**
 * Initialize live regions for announcements
 */
function initializeLiveRegions() {
  // Create live region if it doesn't exist
  if (!document.getElementById('live-region')) {
    const liveRegion = document.createElement('div');
    liveRegion.id = 'live-region';
    liveRegion.setAttribute('role', 'status');
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.style.position = 'absolute';
    liveRegion.style.left = '-10000px';
    liveRegion.style.width = '1px';
    liveRegion.style.height = '1px';
    liveRegion.style.overflow = 'hidden';
    document.body.appendChild(liveRegion);
  }
  
  // Announce cart updates
  window.announceMessage = function(message) {
    const liveRegion = document.getElementById('live-region');
    if (liveRegion) {
      liveRegion.textContent = message;
    }
  };
}

/**
 * Initialize modal accessibility
 */
function initializeModals() {
  const modals = document.querySelectorAll('[role="dialog"]');
  
  modals.forEach(modal => {
    // Ensure modal has aria-modal
    if (!modal.hasAttribute('aria-modal')) {
      modal.setAttribute('aria-modal', 'true');
    }
    
    // Trap focus within modal when open
    modal.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        this.setAttribute('aria-hidden', 'true');
      }
      
      if (e.key === 'Tab') {
        const focusableElements = this.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        
        if (focusableElements.length === 0) return;
        
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          }
        } else {
          if (document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      }
    });
    
    // Close modal on Escape
    const closeButton = modal.querySelector('[aria-label*="Close"], [aria-label*="close"]');
    if (closeButton) {
      closeButton.addEventListener('click', function() {
        modal.setAttribute('aria-hidden', 'true');
      });
    }
  });
}

/**
 * Initialize skip link functionality
 */
function initializeSkipLink() {
  const skipLink = document.querySelector('.skip-link');
  if (skipLink) {
    skipLink.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.focus();
        target.scrollIntoView();
      }
    });
  }
}

/**
 * Announce form errors to screen readers
 */
window.announceFormError = function(fieldId, errorMessage) {
  const field = document.getElementById(fieldId);
  if (field) {
    field.setAttribute('aria-invalid', 'true');
    field.setAttribute('aria-describedby', fieldId + '-error');
    
    let errorElement = document.getElementById(fieldId + '-error');
    if (!errorElement) {
      errorElement = document.createElement('span');
      errorElement.id = fieldId + '-error';
      errorElement.setAttribute('role', 'alert');
      errorElement.className = 'error-message';
      field.parentNode.insertBefore(errorElement, field.nextSibling);
    }
    
    errorElement.textContent = errorMessage;
    errorElement.style.display = 'block';
  }
};

/**
 * Clear form errors
 */
window.clearFormError = function(fieldId) {
  const field = document.getElementById(fieldId);
  if (field) {
    field.setAttribute('aria-invalid', 'false');
    const errorElement = document.getElementById(fieldId + '-error');
    if (errorElement) {
      errorElement.style.display = 'none';
    }
  }
};

/**
 * Ensure all images have alt text
 */
function validateImageAltText() {
  const images = document.querySelectorAll('img');
  images.forEach(img => {
    if (!img.hasAttribute('alt') || img.getAttribute('alt').trim() === '') {
      console.warn('Image missing alt text:', img);
      img.setAttribute('alt', 'Image');
    }
  });
}

/**
 * Ensure all buttons have accessible names
 */
function validateButtonLabels() {
  const buttons = document.querySelectorAll('button, [role="button"]');
  buttons.forEach(button => {
    const hasLabel = button.hasAttribute('aria-label') || 
                     button.textContent.trim() !== '' ||
                     button.getAttribute('title');
    
    if (!hasLabel) {
      console.warn('Button missing accessible label:', button);
    }
  });
}

/**
 * Run validation on page load
 */
window.addEventListener('load', function() {
  validateImageAltText();
  validateButtonLabels();
});
